<template>
    <div class="ibox animated fadeInRightBig">
        <div>
            <div class="ibox-title" style="padding-top:5px;"></div>
            <div class="ibox-content">
                <div class="row">
                    <div class="col-md-4 offset-md-4">
                        <h3 class="centered">Para extrair os relatórios referentes, clique em baixar</h3>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-md-3 offset-md-3">
                        <label>Início</label>
                        <datetime
                            v-model="filters.start"
                            class="form-control"
                            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                            value-zone="America/Sao_Paulo"
                            zone="America/Sao_Paulo"
                        ></datetime>
                    </div>
                    <div class="col-md-3">
                        <label>Término</label>
                        <datetime
                            v-model="filters.end"
                            class="form-control"
                            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                            value-zone="America/Sao_Paulo"
                            zone="America/Sao_Paulo"
                        ></datetime>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-md-6 offset-md-3">
                        <table class="table">
                            <thead>
                                <tr class='centered'>
                                    <td>Conteúdo</td>
                                    <td>Data utilizada para filtro</td>
                                    <td>Ações</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="centered">
                                        <b>Assinaturas Individuais</b>
                                    </td>
                                    <td class="centered">
                                        <b>Data de envio</b>
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-success btn-block"
                                            @click="extract('signatureUserSents')"
                                        >
                                            <i class="fa fa-download"></i> Baixar
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filters: {
                start: '',
                end: ''
            }
        };
    },
    methods: {
        extract(extraction) {
            $("#page_loader").show();
            const self = this;
            const api = self.$store.state.api + "extract/";
            self.$http
                .post(api, {
                    filters: {
                        start: self.filters.start.substring(0, 10),
                        end: self.filters.end.substring(0, 10)
                    },
                    type: extraction
                })
                .then(response => {
                    $("#page_loader").hide();
                    window.open(
                        self.$store.getters.url +
                            "downloadExtractByHash/" +
                            response.data,
                        "_blank"
                    );
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                    $("#page_loader").hide();
                });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Extract/Extract.vue